export function alphabetize(obj) {
    const out = {};
    for (const key of Object.keys(obj).sort())out[key] = obj[key];
    return out;
}


//# sourceMappingURL=alphabetize.js.map